import {useEffect, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopyright } from '@fortawesome/free-regular-svg-icons';
//import './footer.css';

function Footer() {

    const [currentYear, setYear] = useState("");

    useEffect(() => {
        // Grabs the current year and sets it in the footer
        let currentDate = new Date();
        setYear(currentDate.getFullYear());
    }, []);

    return (
        <footer className='footer padding-xl border-top'>
            <section className='font-md'>Copyright <FontAwesomeIcon icon={faCopyright} /> {currentYear} Titan Compute.</section>
        </footer>
    );
}

export default Footer;
